import { Tooltip } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routeFor, routes } from 'src/core/constants/routes';

import { NavLink } from '../NavLink/NavLink';
import { useHasAccessToMultiEntityConfig } from '../useHasAccessToMultiEntityConfig';

type Props = {
  company: {
    id: string;
  };
};

export const MultiEntityHubOrganisationLink = ({ company }: Props) => {
  const { t } = useTranslation('global');
  const hasAccessToMultiEntityConfigState = useHasAccessToMultiEntityConfig({
    isEnabled: true,
  });

  const hasAccess =
    hasAccessToMultiEntityConfigState.status === 'success' &&
    hasAccessToMultiEntityConfigState.hasAccess;

  const organisationSettingsPath = routeFor(routes.ORGANISATION_SETTINGS.path, {
    company: company.id,
  });

  const link = (
    <NavLink
      href={organisationSettingsPath}
      iconName="gear"
      isDisabled={!hasAccess}
    >
      {t('organisation.reporting.links.organisation')}
    </NavLink>
  );

  if (!hasAccess) {
    return (
      <Tooltip
        content={t('multiEntityHub.settings.disabledAccessTooltip')}
        placement="right"
      >
        {link}
      </Tooltip>
    );
  }

  return link;
};
